
export const AlignTop = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.41602 18V8.4H11.066V18H9.41602ZM13.266 14.4V8.4H14.916V14.4H13.266ZM6.66602 7.2V6H17.666V7.2H6.66602Z" fill={color}/>
    </svg> 
  );
}